import { render, staticRenderFns } from "./onebox-package.vue?vue&type=template&id=481aea91&"
import script from "./onebox-package.vue?vue&type=script&lang=js&"
export * from "./onebox-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports